<template>
	<div>
		<div>
			<v-autocomplete
				outlined
				single-line
				height="280"
				item-value="id"
				ref="autocomplete"
				:readonly="false"
				@blur="isFocused = false"
				@focus="isFocused = true"
				:items="apiDocs"
				class="api-docs-ac"
				v-model="localSelectedApiDocs"
				item-text="service_name"
				append-icon="mdi-chevron-down"
				label="Choose API documentation"
				:menu-props="autocompleteMenuProps"
				:search-input.sync="searchProfileString"
				:class="{ 'focused-background': isFocused }"
			>
				<template v-slot:prepend-item>
					<div class="width-100 flex-align-center flex-row display-flex pl-2 connections-header">API documentation</div>
				</template>
				<template v-slot:no-data>
					<div class="width-100 display-flex flex-column flex-centerize no-data-container">
						<div>No API documentation here yet</div>
						<div class="no-data-description">Add new API documentation</div>
					</div>
				</template>
				<template v-slot:append-item>
					<AnemicButton @click="onAddNewDocsClicked" class="add-account-button">
						<AppIcon class="mr-1" name="add-new-accound-plus" width="13" />
						Add new API documentation
					</AnemicButton>
				</template>
				<template v-slot:item="data">
					<ApiDocsSelectionItem
						ref="api-doc-selection-item"
						class="width-100"
						:item="data.item"
						@editApiDoc="onEditApiDoc"
						@deleteApiDoc="deleteApiDoc"
					/>
				</template>
			</v-autocomplete>
		</div>
	</div>
</template>
<script>
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import ErrorHandlingService from '@/utils/error-handling-service';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { useApiDocsArr, useApiDocs } from '@/store/modules/aiAssistantApiDocs/getters';
import { fetchAiAssistantApiDocs, setAiAssistantApiDocs, addAiAssistantApiDoc } from '@/store/modules/aiAssistantApiDocs/actions';
import ApiDocsSelectionItem from './ApiDocsSelectionItem';

export default {
	name: 'AddApiDocumentation',
	props: { selectedApiDocs: { type: Number } },
	components: { ApiDocsSelectionItem },

	computed: {
		...mapGettersShorthand({ useApiDocsArr, useApiDocs, selectedProjectId }),
		autocompleteMenuProps() {
			return { contentClass: 'api-docs', rounded: 'lg', closeOnContentClick: true };
		},
		apiDocsMap() {
			return this.useApiDocs;
		},
		apiDocs() {
			return this.useApiDocsArr;
		},
		localSelectedApiDocs: {
			get() {
				return this.selectedApiDocs;
			},
			set(value) {
				if (value || value === 0) {
					this.$emit('update:selectedApiDocs', value);
					this.$emit('update:apiDocNameChange', this.apiDocsMap[value]?.service_name);
				}
			},
		},
	},
	methods: {
		...mapActionsShorthand({ fetchAiAssistantApiDocs, setAiAssistantApiDocs, addAiAssistantApiDoc }),
		onEditApiDoc(val) {
			this.localSelectedApiDocs = val.id;
		},
		deleteApiDoc(id) {
			this.$emit('deleteApiDoc', id);
		},
		async onAddNewDocsClicked() {
			const getApiDocDataFromDialog = ApiDocsSelectionItem.methods.getApiDocDataFromDialog;
			const apiDoc = await getApiDocDataFromDialog();
			if (!apiDoc) {
				return;
			}
			try {
				const res = await this.addAiAssistantApiDoc({ apiDoc, project: this.selectedProjectId });
				this.localSelectedApiDocs = res.id;
			} catch (err) {
				this.$toast.error(`Failed to add api doc: ${ErrorHandlingService.extractErrorMessage(err)}`, { duration: 4500 });
			}
		},
	},
	data: () => ({ isFocused: false, searchProfileString: null }),
	async mounted() {
		try {
			const projectId = this.selectedProjectId;
			await this.fetchAiAssistantApiDocs({ projectId });
		} catch (err) {
			this.$toast.error(`Failed to fetch api docs: ${ErrorHandlingService.extractErrorMessage(err)}`);
		}
	},
};
</script>

<style scoped lang="scss">
.api-docs-ac {
	::v-deep {
		.v-label {
			font-size: 12px;
			margin-top: -10px;
		}
		.v-input__icon {
			margin-top: -10px;
		}
	}
}
.api-docs {
	.v-list-item {
		&.v-list-item--disabled {
			pointer-events: all;
		}
		.v-list-item__title {
			font-size: 14px;
			font-weight: normal;
		}
	}
}

.add-account-button {
	width: 100% !important;
	height: 44px !important;
	padding: 0px !important;
	border-radius: 0px 0px 8px 8px !important;
	background: var(--ask-for-ingreation-background) !important;

	font-size: 14px !important;
	text-transform: none !important;
	color: var(--publish-button-background) !important;

	::v-deep {
		.v-btn__content {
			border-radius: 0px 0px 8px 8px !important;
		}
	}
}

.connections-header {
	height: 31px;
	font-size: 12px;
	font-weight: 600;
	background: transparent;
	border-radius: 8px 8px 0px 0px;
	color: var(--primary-font-color);
	box-shadow: 0px 1px 2px #747f8d55;
}
.no-data-container {
	height: 205px;
	font-size: 12px;
	font-weight: 600;
	color: var(--profile-selection-grey);

	.no-data-description {
		opacity: 0.5;
		font-weight: normal;
	}
}

.connection-status {
	top: -24px;
	width: 20px;
	left: 385px;
	height: 20px;
	position: relative;
}
.locked-explanation {
	background: #e5e5e5;
	font-size: 14px;
	font-weight: bold;
	border-radius: 8px;
	.locked-body {
		font-weight: 300;
		font-size: 12px;
	}
}
</style>
